import {
	ORG_REPORTS_GET,
	ORG_REPORTS_GET_ERROR,
	REPORT_DOWNLOAD_LOADING_TRUE,
	REPORT_DOWNLOAD_LOADING_FALSE,
	REPORT_DOWNLOAD,
	REPORT_DOWNLOAD_ERROR
} from '../actions/types';

const initialState = {
	org_reports: [],
	download_report_loading: { loading: false, report_id: '' },
	reports_errors: {}
}

export default function reportsReducer(state = initialState, action){
	switch(action.type){
		case ORG_REPORTS_GET:
			delete state.reports_errors.organization_reports
			return {
				...state,
				org_reports: action.payload
			}
		case REPORT_DOWNLOAD_LOADING_TRUE:
			return {
				...state,
				download_report_loading: {
					loading: true,
					report_id: action.payload
				}
			}
		case REPORT_DOWNLOAD_LOADING_FALSE:
			return {
				...state,
				download_report_loading: {
					loading: false,
					report_id: action.payload
				}
			}
		case REPORT_DOWNLOAD:
			delete state.reports_errors.download_report
			return {
				...state
			}
		case ORG_REPORTS_GET_ERROR:
		case REPORT_DOWNLOAD_ERROR:
			return {
				...state,
				reports_errors: {
					...state.reports_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
